module.exports = __webpack_public_path__ + "static/img/black-panther.ebfe0b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/black-panther.jpg
// module id = fAjJ
// module chunks = 0